import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
}

export const SectionWrapper = ({ children, className }: SectionWrapperProps) => {
  return (
    <section className={cn("bg-card rounded-lg border shadow-sm", className)}>
      <div className="p-8">{children}</div>
    </section>
  );
};